import styled from "styled-components";
import { tokens } from "@manifesthhqinc/ui-library";

export const TileContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background: ${tokens.color.surface.card};
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.05);
`;

export const TileContent = styled.div`
  display: flex;
  width: 100%;
  height: 110px;
  align-items: center;
  justify-content: center;
`;

export const TileProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 110px;
  height: 110px;
  flex-basis: 110px;
`;

export const TileProgressBarContainer = styled.div`
  width: 72px;
  height: 72px;
`;

export const TileContentMain = styled.div`
  flex: 1;
  padding-left: 12px;
  padding-right: 12px;
  > div {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
  .tile-label {
    min-width: 36px;
    max-width: 36px;
    font-size: 10px;
    flex-basis: 36px;
  }
  .tile-value {
    font-size: 12px;
  }
`;

export const StatusContent = styled.div<{ $isExpanded: boolean }>`
  border-top: 1px solid ${tokens.color.border.card.default};
  ${(props) => props.$isExpanded && `  padding-bottom: 10px;`}
`;

export const StatusContentHeader = styled.div`
  padding: 10px 26px;
  padding-bottom: 0;
  display: flex;
  align-items: center;
  .tile-status-label {
    width: 42px;
    font-size: 10px;
  }
  .tile-status-value {
    font-size: 12px;
    flex: 1;
  }
`;

export const StatusContentDetails = styled.div<{ $isExpanded: boolean }>`
  transition: max-height 0.3s ease-in-out;
  ${(props) =>
    props.$isExpanded
      ? `max-height: 200px;
      height: auto;
      `
      : `max-height: 0px;
      height:0px;`}
  padding: 10px 26px;
  padding-bottom: 0;

  overflow: hidden;
  color: ${tokens.color.text.secondary};

  p {
    max-width: 240px;
    font-size: 12px;
  }
`;
